import { useState, useRef } from 'react';
import { QRCodeCanvas as QRCode } from 'qrcode.react';
import html2canvas from 'html2canvas';
import './VoucherConfirmation.css';

function VoucherConfirmation({ voucher, campaign }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const voucherCardRef = useRef(null);

  const handleSaveQR = async () => {
    if (!voucherCardRef.current) return;
    try {
      const canvas = await html2canvas(voucherCardRef.current, {
        backgroundColor: null,
        scale: 2,
        useCORS: true,
        logging: false,
        onclone: (_doc, clonedEl) => {
          // html2canvas cannot resolve CSS custom properties — inline them
          clonedEl.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
          clonedEl.style.color = '#ffffff';
          clonedEl.style.borderRadius = '16px';
          clonedEl.style.boxShadow = '0 10px 15px -3px rgba(0,0,0,0.08)';
          clonedEl.style.overflow = 'visible';

          const qr = clonedEl.querySelector('.qr-section');
          if (qr) {
            qr.style.background = '#ffffff';
            qr.style.borderRadius = '12px';
          }

          const code = clonedEl.querySelector('.code-display');
          if (code) {
            code.style.background = 'rgba(255,255,255,0.15)';
            code.style.borderRadius = '8px';
            code.style.color = '#ffffff';
          }

          clonedEl.querySelectorAll('.info-item').forEach(item => {
            item.style.borderBottomColor = 'rgba(255,255,255,0.15)';
          });
          clonedEl.querySelectorAll('.info-item span').forEach(s => {
            s.style.color = 'rgba(255,255,255,0.8)';
          });
          clonedEl.querySelectorAll('.info-item strong').forEach(s => {
            s.style.color = '#ffffff';
          });
        },
      });
      const link = document.createElement('a');
      link.download = `voucher-${voucher.code}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (err) {
      const qrCanvas = document.querySelector('#qrcode canvas');
      if (qrCanvas) {
        const link = document.createElement('a');
        link.download = `voucher-${voucher.code}.png`;
        link.href = qrCanvas.toDataURL();
        link.click();
      }
    }
  };

  const handleEmailQR = async () => {
    if (!email) {
      alert('Sila masukkan alamat email');
      return;
    }

    setLoading(true);
    try {
      alert('Kod QR dihantar ke ' + email);
    } catch (err) {
      alert('Gagal menghantar email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="voucher-confirmation animate-fade-in">
      <div className="success-header">
        <div className="success-icon animate-scale-in">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <h1 className="animate-fade-in-up stagger-1">Pendaftaran Berjaya!</h1>
        <p className="animate-fade-in-up stagger-2">Anda telah berdaftar untuk {campaign.name}</p>
      </div>

      <div className="voucher-card animate-fade-in-up stagger-2" ref={voucherCardRef}>
        <div className="voucher-code">
          <label>Kod Voucher Anda</label>
          <div className="code-display">{voucher.code}</div>
        </div>

        <div className="qr-section" id="qrcode">
          <QRCode
            value={`https://kempenku.com/${campaign.uuid}`}
            size={200}
            level="H"
            includeMargin={true}
          />
        </div>

        <div className="voucher-info">
          <div className="info-item">
            <span>Kempen</span>
            <strong>{campaign.name}</strong>
          </div>
          <div className="info-item">
            <span>Jenis</span>
            <strong>{campaign.campaign_type === 'discount' ? 'Diskaun' : campaign.campaign_type === 'cashback' ? 'Cashback' : 'Hadiah'}</strong>
          </div>
          {campaign.campaign_type === 'discount' && campaign.discount_percentage && (
            <div className="info-item">
              <span>Diskaun</span>
              <strong>{campaign.discount_percentage}%</strong>
            </div>
          )}
          {campaign.campaign_type === 'cashback' && campaign.cashback_amount && (
            <div className="info-item">
              <span>Nilai Cashback</span>
              <strong>RM {parseFloat(campaign.cashback_amount).toFixed(2)}</strong>
            </div>
          )}
          <div className="info-item">
            <span>Tarikh Daftar</span>
            <strong>{new Date(voucher.created_at).toLocaleString('ms-MY')}</strong>
          </div>
        </div>
      </div>

      <div className="action-section animate-fade-in-up stagger-3">
        <h3>Simpan Voucher Anda</h3>

        <button onClick={handleSaveQR} className="btn-save">
          Simpan Voucher
        </button>

        <div className="email-section">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Masukkan email anda"
          />
          <button
            onClick={handleEmailQR}
            disabled={loading}
            className="btn-email"
          >
            {loading ? 'Menghantar...' : 'Hantar'}
          </button>
        </div>

        <p className="note">
          Simpan kod voucher <strong>{voucher.code}</strong> atau kod QR.
          Anda perlu kod ini untuk menebus {campaign.campaign_type === 'discount' ? 'diskaun' : campaign.campaign_type === 'cashback' ? 'cashback' : 'hadiah'} anda.
        </p>
      </div>
    </div>
  );
}

export default VoucherConfirmation;
